// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"index-module--layout-wrapper--_etKa","layout":"index-module--layout--2Gpz-"};